import getCard from "./getCard"
import getUserChart from "./getUserChart"
import getScheduleChart from "./getScheduleChart"

export { getCard, getUserChart, getScheduleChart }
const dashboard = { getCard, getUserChart, getScheduleChart }

export default dashboard
